<div mat-dialog-title class="dialog-title p-0">
  <button mat-icon-button mat-dialog-close tabindex="-1" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dialog-content">
  <h2>{{ "Thank you for choosing Solocal." | translate}}</h2>
  <p>{{ "The questionnaire below is intended to gather all the information that will help us get to know you better and understand your needs, your activities, and your competitive environment." | translate}}</p>
  <p><b>🕒{{ "Estimated time to complete the form: 5 minutes" | translate}}</b></p>
  <p>{{ "You have the option to edit the information about your company and add any details necessary for the production of your products." | translate}}</p>
  <p>{{ "We thank you in advance for the time you will take to answer these questions." | translate}}</p>

  <!-- votre produits -->
  <div class="random-block">
    <div class="random-description">
      <p>
        <ng-container *ngFor="let part of steps[currentStep].description.split('##ICON##')">
          {{ part }}
          <mat-icon *ngIf="part !== steps[currentStep].description.split('##ICON##').slice(-1)[0]">help</mat-icon>
        </ng-container>
      </p>
    </div>
    <div class="random-image">
      <img [src]="steps[currentStep].src">
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions class="dialog-footer">
  <div class="navigation">
    <div class="button-wrapper-left">
      <button class="cdc-button previous" mat-flat-button (click)="previousStep()" [disabled]="currentStep === 0" [ngClass]="{ 'deactivated': currentStep === 0 }">
        <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 19">
          <defs>
            <style>
              .st0 {
                fill: #fff;
              }
            </style>
          </defs>
          <polygon class="st0" points="8.9 16.3 3 9.6 8.9 2.9 10.4 4.3 5.7 9.6 10.4 15 8.9 16.3" />
        </svg>
        {{isMobile && !isEmbed  ? '' : ('Previous' | translate)}}
      </button>
    </div>
    <div class="button-wrapper-right">
      <button *ngIf="currentStep < (steps.length - 1)" class="cdc-button next" mat-flat-button (click)="nextStep()">
        {{isMobile && !isEmbed ? '' : ('Next' | translate)}}
        <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 19">
          <defs>
            <style>
              .st0 {
                fill: #fff;
              }
            </style>
          </defs>
          <polygon class="st0" points="5.1 16.3 3.6 15 8.3 9.6 3.6 4.3 5.1 2.9 10.9 9.6 5.1 16.3" />
        </svg>
      </button>
      <button *ngIf="currentStep == (steps.length - 1)"  class="cdc-button next" mat-flat-button (click)="onConfirm()">
        {{ "I start" | translate}}
      </button>
    </div>
  </div>
  <!-- customer manager -->
  <p>
    {{
      (data.manager !== undefined && data.manager !== '')
        ? ('I contact my dedicated advisor {0} on ' | translate: { '0': data.manager }) + '34 01'
        : ('I contact client service on ' | translate) + '34 01'
    }}
    ({{ 'Free service + call price' | translate }})
  </p>
</mat-dialog-actions>

